<script setup lang="ts">
// types
import type { SectionHeroTextProps } from '@ts-sections/section-hero-text/interfaces'
import { AppText } from '@UI/Typography/AppText'

defineOptions({
  name: 'SectionHeroText',
})

defineProps<{
  section: SectionHeroTextProps
}>()
</script>

<template>
  <section
    v-if="section.title || section.description"
    class="section-hero-text"
    :data-component="section.__component"
  >
    <AppText
      v-if="section.title"
      tag="h1"
      :name="{ base: 'h3', 740: 'h1' }"
      color="slate-900"
    >
      {{ section.title }}
    </AppText>
    <AppText
      v-if="section.description"
      name="body2"
      color="slate-700"
    >
      {{ section.description }}
    </AppText>
  </section>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionHeroText.scss" />
